import './index.css';
import ArrowBackLight from '../../images/arrow-back-light.png';
import Hint from '../../images/hint.png';
import {flutterUser, insets} from "../../util";
import Rank1 from "../../images/rank-1.png";
import Rank2 from "../../images/rank-2.png";
import Rank3 from "../../images/rank-3.png";
import {useEffect, useState} from "react";
import JsonRequest from "../../request/json_request";
import Avatar from "../../images/avatar.png";
import {Tooltip} from "react-tooltip";

export default () => {
    const paddingTop = insets.paddingTop === 0 ? 20 : insets.paddingTop + 20;
    const rankImgs = [Rank1, Rank2, Rank3];
    const [rankType, setRankType] = useState('');
    const client = JsonRequest.headerClient(flutterUser);
    const [owner, setOwner] = useState({})
    const [rankList, setRankList] = useState([]);
    const [totalOwner, setTotalOwner] = useState(12138);

    useEffect(() => {
        getRankList(rankType);
    }, []);

    const resetRankType = (type) => {
        if (type === rankType) return;
        setRankType(type);
        getRankList(type);
    }

    const getRankList = (type) => {
        client.get(`/api/std/app/v2/share/coin/rank/acupoint:coin:event::clock-in-continuous`,
            {type})
            .then(resp => resp.json())
            .then(({data}) => {
                console.log(data);
                if (data?.owner)
                    setOwner({
                        ...data?.owner,
                        rank_count: getOwnerRank(data),
                    });
                setRankList(data?.rank);
                setTotalOwner((data?.total_owner || 0) + 12138);
            })
    }

    const getOwnerRank = ({owner, rank}) => {
        const index = rank.findIndex(item => item.owner_id === owner.owner_id);
        return index + 1;
    }

    // 顶部导航组件
    const RankHeader = () => (
        <div className="rank-header" style={{paddingTop: `${paddingTop}px`}}>
            <div className='rank-header-navigate'>
                <img className='rank-back' src={ArrowBackLight} alt='' onClick={() => window.history.back(-1)}/>
                <div className="rank-header-tabs">
                    <span className={`rank-tabs ${rankType === 'month' && 'rank-tabs-select'}`}
                          onClick={() => resetRankType('month')}>月榜</span>
                    <span className='rank-tabs-divider'></span>
                    <span className={`rank-tabs ${rankType === '' && 'rank-tabs-select'}`}
                          onClick={() => resetRankType('')}>总榜</span>
                </div>
                <img data-tooltip-id="rank-tooltip" data-tooltip-content="排行榜数据每日10:00更新" className='rank-hint'
                     src={Hint} alt=''/>
                <Tooltip id="rank-tooltip"
                         openOnClick={true} place={'bottom-start'}>
                </Tooltip>
            </div>
            <RankTitle/>
        </div>
    );

    // 标题部分组件
    const RankTitle = () => (
        <div className="rank-title">
            <h1>签到排行榜</h1>
            <p>{totalOwner}位中医人，坚持签到，小坚持，大成长</p>
        </div>
    );

    // 单个排名项组件
    const RankItem = ({ranking, avatar, nickName, total_amount, total_count, rank_count, owner}) => (
        <div className={`rank-item ${ranking % 2 === 0 ? 'rank-back-color' : ''}`}>
            {!owner && (ranking <= 3 ? <img className='ranking' src={rankImgs[ranking - 1]} alt=""/> :
                <div className="ranking">{ranking}</div>)}
            <div className="user-info">
                <img className="avatar" src={avatar ? avatar.startsWith('http') ? avatar :
                    `https://api.lighttcm.com/api/attach/${avatar}` : Avatar} alt="avatar"/>
                <div className='user-name-info'>
                    <span className="username">{nickName}</span>
                    {owner && <span className='user-info-sub-text'>签到{total_count || 0}天</span>}
                </div>
            </div>
            <div
                className="days">{owner ? (rank_count > 0 ? `第${rank_count}名` : '未上榜') : `${total_amount}天`}</div>
        </div>
    );

    // 排行榜列表组件
    const RankListItems = () => (
        <div className="rank-list-items" style={{paddingBottom: `${insets.paddingBottom + 56}px`}}>
            {rankList?.map((item, index) => (
                <RankItem key={item.owner_id} {...{ranking: index + 1, ...item}} />
            ))}
        </div>
    );

    const RankMine = () => (
        <div className="rank-mine" style={{paddingBottom: `${insets.paddingBottom}px`}}>
            <RankItem {...{ranking: owner.total_count, ...owner}} owner/>
        </div>
    )

    return (
        <div className="rank-list">
            <RankHeader/>
            <RankListItems/>
            <RankMine/>
        </div>
    )
}